import { Userpilot } from 'userpilot';

import {
  GleapBooleanTrait,
  trackGleapBooleanTraitEnabled,
  updateGleapCustomData,
} from 'services/gleap';

export function updateWorkspaceBooleanTrait({
  userId,
  workspaceId,
  trait,
  value,
}: {
  userId: string;
  workspaceId?: string;
  trait: GleapBooleanTrait;
  value: boolean;
}) {
  const traits = {
    [trait]: value,
    application_id: workspaceId,
  };

  Userpilot.identify(userId, traits);
  updateGleapCustomData(traits);

  if (!workspaceId) {
    return;
  }

  trackGleapBooleanTraitEnabled({
    userId,
    workspaceId,
    trait,
    value,
  });
}
